export default __webpack_public_path__ + "static/media/Giftcard.035533ad.png";